module.exports = __webpack_public_path__ + "static/015-f975c5da59e5df2d1f684383d0ee0ffd.jpg";